import React from 'react';
import PropTypes from 'prop-types';
import css from './InputTime.module.scss';

const InputTime = ({
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`${css.inputContainer} ${className}`}>
      {label && (
        <label className={css.label} htmlFor={name}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.inputWrapper}>
        {icon && <div className={css.iconContainer}>{icon}</div>}
        <input
          type="time"
          value={value || ''}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          name={name}
          id={name}
          autoFocus={autoFocus}
          onKeyDown={onKeyDown}
          className={`${css.input} ${error ? css.error : ''} ${icon ? css.hasIcon : ''}`}
          data-error={!!error}
        />
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

InputTime.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func
};

export default InputTime;


